import type {
  DashboardStatusOption,
  DashboardStatusFilter,
  ExperimentStatus,
  PipelineStage,
} from "../types/dashboard.types";

export const EXPERIMENT_STATUS_LIST = [
  "draft",
  "locked",
  "active",
  "paused",
  "completed",
  "deleted",
] as const satisfies readonly ExperimentStatus[];

export const STATUS_FILTER_VALUES = [
  "all",
  ...EXPERIMENT_STATUS_LIST,
] as const satisfies readonly DashboardStatusFilter[];

export const PIPELINE_STAGE_CONFIG: PipelineStage[] = [
  {
    key: "draft",
    label: "DRAFT",
    count: 0,
    dotColor: "#5C5C5C",
  },
  {
    key: "locked",
    label: "LOCKED",
    count: 0,
    dotColor: "#2F66C4",
  },
  {
    key: "active",
    label: "ACTIVE",
    count: 0,
    dotColor: "#56D36D",
  },
  {
    key: "paused",
    label: "PAUSED",
    count: 0,
    dotColor: "#D3AF3A",
  },
  {
    key: "completed",
    label: "COMPLETED",
    count: 0,
    dotColor: "#D3AF3A",
  },
];

export const STATUS_FILTER_OPTIONS: DashboardStatusOption[] = [
  { value: "all", label: "All", iconKey: "all" },
  { value: "draft", label: "Draft", iconKey: "draft" },
  { value: "locked", label: "Locked", iconKey: "locked" },
  { value: "active", label: "Active", iconKey: "active" },
  { value: "paused", label: "Paused", iconKey: "paused" },
  { value: "completed", label: "Completed", iconKey: "completed" },
  { value: "deleted", label: "Deleted", iconKey: "deleted" },
];
